import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import * as colors from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { HOURS_CLASSES } from "./constants";

export const HoursContainer = styled(Box)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);

  return {
    marginBottom: theme.spacing(3),
    [formatMedia.BREAKPOINT_TABLET]: { marginBottom: theme.spacing(2) },

    [`& .${HOURS_CLASSES.detailsLabel}`]: {
      marginBottom: theme.spacing(0.5),
      color: colors.COLOR_GREYSCALE_BLACK_54,
      ...theme.typography.body2,
      [formatMedia.BREAKPOINT_TABLET]: {
        marginBottom: theme.spacing(1),
        fontSize: 14,
      },
    },

    [`& .${HOURS_CLASSES.detailsText}`]: {
      display: "flex",
      alignItems: "center",
      ...theme.typography.body1,
      [formatMedia.BREAKPOINT_TABLET]: {
        fontSize: 14,
        letterSpacing: "0.01em",
      },
      "& > svg": { marginLeft: theme.spacing(1) },
    },

    [`& .${HOURS_CLASSES.detailsTextLink}`]: {
      cursor: "pointer",
    },

    [`& .${HOURS_CLASSES.hours}`]: {
      display: "flex",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
      "& > ol": { marginRight: theme.spacing(2), padding: 0 },
      [formatMedia.BREAKPOINT_TABLET]: { marginBottom: theme.spacing(1) },
    },

    [`& .${HOURS_CLASSES.hoursText}`]: {
      ...theme.typography.body1,
      display: "flex",
      justifyContent: "space-between",
      gap: theme.spacing(2),
      padding: 0,
      [formatMedia.BREAKPOINT_TABLET]: {
        fontSize: 14,
        lineHeight: "20px",
        letterSpacing: "0.01em",
      },
    },

    [`& .${HOURS_CLASSES.hoursCurrent}`]: {
      ...theme.typography.body1,
      fontWeight: 700,
      [formatMedia.BREAKPOINT_TABLET]: {
        fontSize: 14,
        letterSpacing: "0.01em",
      },
    },

    [`& .${HOURS_CLASSES.hoursSpecial}`]: {
      marginTop: theme.spacing(1),
      padding: theme.spacing(1, 1.5),
      backgroundColor: colors.COLOR_ADDITIONAL_WARM_GRAY_3U,
    },

    [`& .${HOURS_CLASSES.hoursSpecialText}`]: {
      ...theme.typography.body1,
      [formatMedia.BREAKPOINT_TABLET]: { fontSize: 14 },
    },
  };
});
